import {ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit, signal} from '@angular/core';
import {ServiceProvider, TaskMessageStatus} from "@portbase/bezoekschip-service-typescriptmodels";
import {FormGroupDirective} from "@angular/forms";
import {sendQuery} from "../../../../common/utils";
import {rxResource, takeUntilDestroyed} from "@angular/core/rxjs-interop";
import { map } from 'rxjs';

@Component({
    selector: 'app-operational-services-editor',
    templateUrl: './operational-services-editor.component.html',
    styleUrl: './operational-services-editor.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class OperationalServicesEditorComponent implements OnInit {

  protected readonly form = inject(FormGroupDirective);
  private readonly destroyRef = inject(DestroyRef);

  public readonly portUnCode = input<string>();
  protected readonly tugboatOrganizationsResource = rxResource<string[], string>({
    params: () => this.portUnCode(),
    stream: ({ params }) =>
      sendQuery(
        "com.portbase.bezoekschip.common.api.visit.GetTugboats",
        { portUnCode: params }
      ).pipe(map(serviceProviders => serviceProviders.map(
        serviceProvider => serviceProvider.name
      ))),
    defaultValue: []
  });

  protected readonly servicesValues = signal<OperationServicesValues | null>(null);

  protected readonly numberOfTugboatOptions = [
    1,2,3,4,5,6,7,8,9,'LAB'
  ]

  protected readonly pilotApprovalOptions = [
    TaskMessageStatus.UNKNOWN,
    TaskMessageStatus.ACCEPTED,
    TaskMessageStatus.WARNING,
    TaskMessageStatus.REJECTED
  ];

  protected readonly booleanOptions = [
    true,
    false
  ];

  protected booleanFormatter(value: boolean) {
    if (value) {
      return "Yes";
    } else {
      return "No"
    }
  }

  ngOnInit(): void {
    this.servicesValues.set(
      this.form.control.get("services")?.value
    );
    this.form.control.get("services")?.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(
      value => this.servicesValues.set(value)
    );
  }
}

interface OperationServicesValues {
  pilot: boolean
  tugboat: boolean
  boatmen: boolean
}
